<template>
  <div>
    <i
      v-if="showPublished"
      class="fas fa-globe mr-2"
      title="AKTUALISIERT"
    />
    <i
      v-if="showDeactivated"
      class="fas fa-ban mr-2"
      title="DEACTIVATED"
    />
    <i
      v-if="showEdit"
      class="fas fa-pen"
      title="EDIT"
    />
  </div>
</template>

<script>
export default {
  props: {
    states: {
      type: String,
      required: true,
    },
  },
  computed: {
    showPublished() {
      var statesArray = this.states.split(",");

      for (var element of statesArray) {
        if (element == "Aktualisiert") {
          return true;
        }
      }

      return false;
    },
    showDeactivated() {
      var statesArray = this.states.split(",");

      for (var element of statesArray) {
        if (element == "Deactivated") {
          return true;
        }
      }

      return false;
    },
    showEdit() {
      var statesArray = this.states.split(",");

      if (statesArray[0] == "Edit") {
        return true;
      }

      return false;
    },
  },
};
</script>
